import React, { useState } from "react";
import { ICreateExpenseData } from "../../../@types";
import { Tooltip } from "../../../assets/icons/Tooltip";
import { CheckboxComponent } from "../../core/Forms";

interface ProtectedProps {
  validationResults: ICreateExpenseData;
  formData: ICreateExpenseData;
  handleIsProtectedChange: () => void;
  isProtected: boolean;
  toolTipText?: string;
}

const ProtectedExpense: React.FC<ProtectedProps> = ({
  handleIsProtectedChange,
  isProtected,
  toolTipText,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="flex md:justify-between  gap-2 items-center md:px-[1em] md:py-[0.7em]">
    
      <span className="inline-flex gap-[8.5px]">
  <div className="mt-[0.5em] lg:mt-[5px]">
    <label className="inline-flex items-center">
      <input
        type="checkbox"
        checked={isProtected}
        className="h-4 w-4 border-gray-300 rounded text-[#044E97] focus:ring-blue-500"
        onChange={handleIsProtectedChange}
        name="isProtected"
      />
    </label>
  </div>
</span>

      <div className="flex justify-start mt-[0.1px] md:gap-3">
        <label
          htmlFor="reoccurring"
          className="font-semibold block text-[14px]  lg:text-[16px] lg:ml-0 "
        >
          Restrict access to admins only
        </label>

        {/* {toolTipText && (
          <div
            className="relative lg:mt-[0.8em]"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <Tooltip />
            {isHovered && (
              <div className="absolute w-[204px] left-[-5.7em] z-10">
                <div className="flex items-center justify-center">
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M9 0L17.6603 15H0.339746L9 0Z" fill="#FFF4C6" />
                  </svg>
                </div>
                <div className="p-3 bg-[#FFF4C6] rounded-[4px] text-[12px] font-medium leading-[14.4px]">
                  {toolTipText}
                </div>
              </div>
            )}
          </div>
        )} */}
      </div>
    
    </div>
  );
};

export default ProtectedExpense;
